<div class="program-share" [class.open]="isOpen">
  <button type="button" class="program-share-toggle" (click)="toggle($event)" aria-label="Share">
    <i class="material-symbols-outlined">share</i>
  </button>
  <div class="program-share-popup" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="program-share-icons">
      <a [href]="links.facebook" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on Facebook">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a [href]="links.linkedin" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on LinkedIn">
        <i class="fab fa-linkedin-in"></i>
      </a>
      <a [href]="links.whatsapp" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on WhatsApp">
        <i class="fab fa-whatsapp"></i>
      </a>
      <a [href]="links.email" class="program-share-link" aria-label="Share via Email">
        <i class="fas fa-envelope"></i>
      </a>
      <a [href]="links.instagram" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on Instagram">
        <i class="fab fa-instagram"></i>
      </a>
    </div>
    <div class="program-share-copy">
      <input type="text" readonly [value]="url" (click)="$any($event.target).select()" aria-label="Shareable link" />
      <button type="button" (click)="copyLink($event)">{{ copied ? 'Copied' : 'Copy' }}</button>
    </div>
  </div>
</div>
